/** 
  Author: Lokesh Arora - lokesh.arora@enabledata.com
  Purpose: Role api models
  Date: April 2020
**/

import { action, thunk } from 'easy-peasy';
import * as roleService from '../../services/role';

const roleModel = {
  roleList: [],
  setRoleList: action((state, payload) => {
    state.roleList = payload;
  }),

  getRoleList: thunk(async (actions, payload) => {
    await roleService
      .getRoleList(payload)
      .then(function (response) {
        actions.setRoleList(response.data.data.roles);
      })
      .catch(function (error) {
        console.log('Error', error);
        actions.setRoleList([]);
      });
  }),
  
 
};

export default roleModel;
